var map = {
	"./gameplay-betto-medium.webp": [
		74099,
		74099
	],
	"./gameplay-chainspin-medium.webp": [
		8791,
		8791
	],
	"./gameplay-chokwin-medium.webp": [
		24100,
		24100
	],
	"./gameplay-coinebet-medium.webp": [
		6393,
		6393
	],
	"./gameplay-flashsportscasino-medium.webp": [
		70073,
		70073
	],
	"./gameplay-gannar-medium.webp": [
		90930,
		90930
	],
	"./gameplay-luckykingbet-medium.webp": [
		93464,
		93464
	],
	"./gameplay-mars-br-medium.webp": [
		29404,
		29404
	],
	"./gameplay-mars-es-medium.webp": [
		75057,
		75057
	],
	"./gameplay-mars-medium.webp": [
		86942,
		86942
	],
	"./gameplay-mars-mx-medium.webp": [
		16683,
		16683
	],
	"./gameplay-mars-pt-medium.webp": [
		24626,
		24626
	],
	"./gameplay-mars-ru-medium.webp": [
		22974,
		22974
	],
	"./gameplay-mars-th-medium.webp": [
		37405,
		37405
	],
	"./gameplay-novero-medium.webp": [
		18204,
		18204
	],
	"./gameplay-rollblock-medium.webp": [
		10991,
		21052
	],
	"./gameplay-zigybet-medium.webp": [
		94833,
		94833
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83745;
module.exports = webpackAsyncContext;